import React, { useRef, useState, useEffect, useCallback, useMemo } from "react";
import {
  Layout,
  Col,
  Row,
  Tabs,
  Tag,
  Input,
  Button,
  Popover,
  Card,
  Menu,
  Dropdown,
  Select,
  Icon,
  Modal,
  Checkbox,
} from "antd";
import {
  TagCloseIcon,
  EditIconSidebar,
  NotesEditMenuIcon,
  NoteDeleteIcon,
  NotePinIcon,
  NotePinnedIcon,
  HighPriorityTagIcon,
  ExpediteTagIcon,
  SpecialTagIcon,
  HazmatTagIcon,
  SelectedTickMarkIcon,
  TagsModalCloseIcon,
  InstructionsAddIcon,
  TagsTooltipIcon,
  OsdTagIcon,
  AppointmentIcon
} from "../../common/CustomIcon";
import { calculateDaysDifference } from "../../helpers/date_functions";
import { dispatcherNotesApi, privateNotesApi } from "../../api/OrdersApi";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import I18n from "../../common/I18n";
import { renderAlertMessage } from "../../helpers/common";
import { alertMessage, findNumberTotal, randomNumber } from "../../common/Common";
import Button_v2 from "./Button_v2";
import { updateOrderDetails_v2 } from "../../api/OrdersApi";
import ReferenceNumberSectionView from "./ReferenceNumberSectionView";
import OptionsSectionView from "./OptionsSectionView";
import Copyable from "../../components/common/Copyable";
import { createTag,fetchTagsFromAPI } from "../../api/OrdersApi";
import InfoTooltip from "./InfoTooltip";
import OrderStatusDropdown from "../../components/orders/OrderStatusDropdown";
import { Spin} from '../../common/UIComponents'
import "../../../stylesheets/OrderAmountSummary.scss";
import EstimateBill from "./orders/rightSidebar/EstimateBill";
import { at } from "lodash";
import DisplayTime from "../../components/common/DisplayTime";

const { TabPane } = Tabs;
const { TextArea } = Input;

const OrderViewSidebar = (props) => {
  const { currentOrder, currentOrg,organizationSettings, refer_type = "order" ,consolidatedData,setActiveKey,orderResponse,refreshDetails,
     setViewTab ,goToTab,setShowDrawer, isShipper = false, estimateRefreshKey, orgRules, setEstimateRefreshKey = () => {}, updateNotes, updateTags, updateReferences, updateOptionsAndTags, updateDispatchNotes, updateInternalNotes , updateConsigneeNotes, onUnmount = () => {},
     autoOpenImportModal = false, onImportModalOpened = () => {},
  } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [availableTags, setAvailableTags] = useState([]);
  const [customTags , setCustomTags] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [hoveredField, setHoveredField] = useState(null);
  const excludedTags = ["special", "hazmat", "priority", "expedite","delivery_special","pickup_special","linehaul_special", "appointment"];
  const [inProgress,setInprogress] =  useState(false);
  const [locked, setLocked] = useState(false); 
  useEffect(() => {
    if (isShipper || orderResponse?.customer_order_details?.is_locked !== undefined) {
        setLocked(isShipper || orderResponse.customer_order_details.is_locked === "true" || orderResponse?.is_deleted_order ? true : false);
    }
}, [orderResponse]);
  const handleTagInputChange = (e) => {
    setTagInput(e.target.value);
  };
  useEffect(() => {
    const fetchTags = async () => {
        const organizationId = currentOrg?.id;
        try {
          const response = await fetchTagsFromAPI(organizationId);
            if (response?.success && Array.isArray(response.tags)) {
              setCustomTags(response.tags.map(tag => ({
                    id: tag.id,
                    name: tag.tag_name,
                    description: tag.tag_description,
                })));
            } else {
              setCustomTags([]);
            }
        } catch (error) {
            console.error("Failed to fetch tags:", error);
            setCustomTags([]);
        }
    };
    fetchTags();
}, [currentOrg, refreshKey]);

  const getNotesInfo = () => {
    const dispatcherNotes = currentOrder?.dispatcher_notes ? currentOrder.dispatcher_notes.map(note => ({ ...note, type: 'DISPATCHER', pinned: note.is_pinned })) : [];
    const consigneeNotes = currentOrder?.consignee_notes ? currentOrder.consignee_notes.map(note => ({ ...note, type: 'CONSIGNEE', pinned: note.is_pinned })) : [];
    const driverNotes = currentOrder?.customer_order_details?.driver_notes ? currentOrder.customer_order_details.driver_notes.map(note => ({ ...note, id: randomNumber(), type: 'DRIVER', pinned: note.is_pinned })) : [];
    const allDispatcherNotes = [].concat(dispatcherNotes, driverNotes)
    return (
      {
        notes: currentOrder?.notes || "",
        consigneeNotes: consigneeNotes,
        tags: currentOrder?.customer_order_details?.tags || [],
        dispatchNotes: [...allDispatcherNotes],
        internalNotes: currentOrder?.internal_notes ? currentOrder.internal_notes.map(note => ({ ...note, type: 'INTERNAL', pinned: note.is_pinned })) : [],
      }
    )
  }

  const getLabel = (type) => {
    switch (type) {
      case 'DRIVER': return 'Driver';
      case 'CONSIGNEE': return 'Consignee';
      case 'INTERNAL': return 'Internal';
      case 'DISPATCHER': return 'Dispatch';
      default: return "";
    }
  }
  const emptyText = "Not Available";
  const initialOrderDetails = getNotesInfo()

  const [isLoading, setIsLoading] = useState(false);
  const [newNote, setNewNote] = useState("");
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState(initialOrderDetails.tags);
  const [notes, setNotes] = useState(initialOrderDetails.notes);
  const [tempNotes, setTempNotes] = useState(notes);
  const [isHoveringInstructions, setIsHoveringInstructions] = useState(false);
  const [isInstructionsPopoverVisible, setIsInstructionsPopoverVisible] =
    useState(false);
  const [dispatchNotes, setDispatchNotes] = useState(
    initialOrderDetails.dispatchNotes
  );
  const [internalNotes, setInternalNotes] = useState(
    initialOrderDetails.internalNotes
  );
  const [consigneeNotes, setConsigneeNotes] = useState(
    initialOrderDetails.consigneeNotes
  );

  const [selectedNoteFilter, setSelectedNoteFilter] = useState("ALL");
  const [open, setOpen] = useState(false);
  const [selectedNoteTypeForAdd, setSelectedNoteTypeForAdd] = useState("DISPATCHER");
  const [selectedNoteTypeForEdit, setSelectedNoteTypeForEdit] = useState("");

  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editedNoteContent, setEditedNoteContent] = useState("");
  const sidebarRef = useRef(null);
const [isOverflowing, setIsOverflowing] = useState(false);
const [atBottom, setAtBottom] = useState(false);

  const handleInstructionsEdit = () => {
    const notesWithNewlines = notes.replace(/<br\s*\/?>/gi, '\n');
    setTempNotes(notesWithNewlines);
    setIsInstructionsPopoverVisible(true);
  };
  
  useEffect(() => {
    const checkOverflow = () => {
      const el = sidebarRef.current;
      if (el) {
        setIsOverflowing((el.scrollHeight - 60 )> el.clientHeight);
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  const checkScrollPosition = () => {
    const el = sidebarRef.current;
    if (el) {
      setAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 5);
    }
  };



  useEffect(() => {
    const initialOrderDetails = getNotesInfo()
    setTags(initialOrderDetails.tags)
    setNotes(initialOrderDetails.notes);
    setDispatchNotes(initialOrderDetails.dispatchNotes)
    setInternalNotes(initialOrderDetails.internalNotes)
    setConsigneeNotes(initialOrderDetails.consigneeNotes)
  }, [currentOrder])
  const inputRef = useRef(null);

  const handleTagsUpdate = (updatedTags) => {
    setTags(updatedTags);
};
const handleScrollToEnd = () => {
  if (sidebarRef.current) {
    sidebarRef.current.scrollTo({
      top: sidebarRef.current.scrollHeight, 
      behavior: "smooth", 
    });
  }
};

  const handleInstructionsSave = useCallback(() => {
    const formattedNotes = tempNotes.replace(/\n/g, "<br />");
    setNotes(formattedNotes);
    updateNotes({ notes: formattedNotes});
    updateOrder("notes", formattedNotes);
    setIsInstructionsPopoverVisible(false);
  }, [tempNotes, notes, updateOrder]);

  const handleInstructionsCancel = () => {
    setTempNotes(notes);
    setIsInstructionsPopoverVisible(false);
  };

  const noteFilterOptions = [
    { value: "ALL", label: "All Notes" },
    { value: "INTERNAL", label: "Internal Notes" },
    { value: "DISPATCHER", label: "Dispatch Notes" },
    { value: "CONSIGNEE", label: "Consignee Notes" },
  ];
  const noteAddTypeOptions = [
    { key: "DISPATCHER", label: "Disptach" },
    { key: "INTERNAL", label: "Internal" }
  ]
  const handleDropdownChange = (openStatus) => {
    setOpen(openStatus);
  };

  const handleAddNote = (id, type, action = 'add') => {
   
    if (!id) {
      if (!newNote) return;
    } else {
      if (!editedNoteContent) return;
    }
    const keyToConsider = action === 'add' ? selectedNoteTypeForAdd : type

    const apiEndpoint = keyToConsider === "INTERNAL"
    ? privateNotesApi
      : dispatcherNotesApi

    const apiPayload = {
      customer_order_id: currentOrder?.id || "",
      notes: newNote,
      organization_id: currentOrg?.id || "",
      refer_type: refer_type,
      ...(keyToConsider !== "INTERNAL" && { notes_type: keyToConsider }),
    };

    if (keyToConsider === "INTERNAL") {
      apiPayload.private_notes = newNote;
    }
    setInprogress(true);
   
    if (!id) {
      setIsLoading(true);
      apiEndpoint
        .create(apiPayload)
        .then((res) => {
          if (res.success) {
            const noteToAdd = _.pick(res.dispatch_notes, [
              "id",
              keyToConsider === "INTERNAL" ? "private_notes" : "notes",
              "notes_type",
              "last_updated_by",
              "updated_at",
            ]);

            // Update local state based on note type
            if (keyToConsider === "DISPATCHER") {
              setDispatchNotes((prevNotes) => [...prevNotes, { ...noteToAdd, type: 'DISPATCHER' }]);
              updateDispatchNotes({
                dispatchNotes: [...dispatchNotes, { ...noteToAdd }],
              })
            } else if (keyToConsider === "INTERNAL") {
              setInternalNotes((prevNotes) => [
                ...prevNotes,
                { ...noteToAdd, notes: newNote, type: 'INTERNAL' }, // Adding the note to internal
              ]);
              updateInternalNotes({
                internalNotes: [...internalNotes, { ...noteToAdd, notes: noteToAdd.private_notes || newNote }],
              })
            }
            else if (keyToConsider === "CONSIGNEE") {
              setConsigneeNotes((prevNotes) => [...prevNotes, { ...noteToAdd, type: 'CONSIGNEE' }]);
              updateConsigneeNotes({
                consigneeNotes: [...consigneeNotes, { ...noteToAdd }],
              });
            }

            setNewNote(""); // Clear the input field
            renderNotification(I18n.t("messages.saved"), "success");
            setInprogress(false);
          } else {
            renderAlertMessage(res.errors);
          }
        })
        .finally(() => {
          setIsLoading(false);
          inputRef.current.focus();
        });
    } else {
    
      apiPayload.customer_order_notes_id = id || "";
      apiPayload.notes = editedNoteContent || "";
      if (keyToConsider === "INTERNAL") {
        apiPayload.private_notes = editedNoteContent;
      }
      delete apiPayload.customer_order_id; 

      setIsLoading(true);
      const index = 0; 

      apiEndpoint
        .update(apiPayload)
        .then((res) => {
          if (res.success) {
            if (keyToConsider === "DISPATCHER") {
              setDispatchNotes((prevNotes) =>
                prevNotes.map((note) =>
                  note.id === editingNoteId
                    ? { ...note, notes: editedNoteContent, updated_at: res?.dispatch_notes?.updated_at }
                    : note
                )
              );
              updateDispatchNotes({
                dispatchNotes: dispatchNotes.map((note) =>
                  note.id === editingNoteId
                    ? { ...note, notes: editedNoteContent, updated_at: res?.dispatch_notes?.updated_at }
                    : note
                )});
            } else if (keyToConsider === "INTERNAL") {
              setInternalNotes((prevNotes) =>
                prevNotes.map((note) =>
                  note.id === editingNoteId
                    ? { ...note, notes: editedNoteContent, updated_at: res?.dispatch_notes?.updated_at }
                    : note
                )
              );
              updateInternalNotes({
                internalNotes: internalNotes.map((note) =>
                  note.id === editingNoteId
                    ? { ...note, notes: editedNoteContent, updated_at: res?.dispatch_notes?.updated_at }
                    : note
                )});
            }
            else if (keyToConsider === "CONSIGNEE") {
              setConsigneeNotes((prevNotes) =>  
                prevNotes.map((note) =>
                  note.id === editingNoteId
                    ? { ...note, notes: editedNoteContent, updated_at: res?.dispatch_notes?.updated_at }
                    : note
                )
              );
              updateConsigneeNotes({
                consigneeNotes: consigneeNotes.map((note) =>
                  note.id === editingNoteId
                    ? { ...note, notes: editedNoteContent, updated_at: res?.dispatch_notes?.updated_at }
                    : note
                )});
            }

            setEditingNoteId(null);
            setEditedNoteContent("");
            alertMessage(I18n.t("messages.saved"));
            setInprogress(false);
          } else {
            renderAlertMessage(res.errors);
          }
        })
        .finally(() => {
          setIsLoading(false);
         if (inputRef?.current) {
            inputRef.current.focus();
          }
        });
    }
  };
  const handleDelete = (id, noteType) => {
    const apiEndpoint =
      noteType === "INTERNAL" ? privateNotesApi : dispatcherNotesApi;
    setIsLoading(true);
    apiEndpoint
      .delete(id, noteType)
      .then((res) => {
        if (res.success) {
          if (noteType === "DISPATCHER") {
            setDispatchNotes((prevNotes) =>
              prevNotes.filter((note) => note.id !== id)
            );
            updateDispatchNotes({
              dispatchNotes: dispatchNotes.filter((note) => note.id !== id)
            });
          } else if (noteType === "INTERNAL") {
            setInternalNotes((prevNotes) =>
              prevNotes.filter((note) => note.id !== id)
            );
            updateInternalNotes({
              internalNotes: internalNotes.filter((note) => note.id !== id)
            });
          }
          else if (noteType === "CONSIGNEE") {
            setConsigneeNotes((prevNotes) =>
              prevNotes.filter((note) => note.id !== id)
            );
            updateConsigneeNotes({
              consigneeNotes: consigneeNotes.filter((note) => note.id !== id)
            });
          }
          renderNotification(I18n.t("messages.deleted"), "success");
        } else {
          renderAlertMessage(result.errors);
        }
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          inputRef.current.focus();
        }, 0);
      });
  };

  // const handleTagSubmit = () => {
  //   if (tagInput) {
  //     const updatedTags = [...tags, tagInput];
  //     setTags(updatedTags);
  //     setTagInput("");

  //     updateOrder("tags", updatedTags);
  //   }
  //   setIsPopoverVisible(false);
  // };

  const handleTagSubmit = () => {
    if (tagInput && !availableTags.includes(tagInput)) {
      setAvailableTags((prev) => [...prev, tagInput]);
    }
    handleTagCheckboxChange(tagInput);
    setTagInput("");
  };

  //Tag Removal
  const handleRemoveTag = (tagToRemove) => {
    const updatedTags = tags.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
    updateOrder("tags", updatedTags);
  };

  const updateOrder = (element, value) => {
    const payload = {
      customer_order_params: {
        customer_order_id: currentOrder.id,
        warehouse_id: currentOrder?.customer_order_details?.warehouse_id || "",
        organization_id: currentOrg?.id || "",
        location_id: "",
      },
      [element]: value,
    };

    updateOrderDetails_v2(currentOrder.id, payload)
      .then((res) => {
        if (res.success) {
          if(element === "tags"){
            setTags(value)
          }
          renderNotification(I18n.t("messages.saved"), "success");
        } else {
          renderAlertMessage(res.errors);
        }
      })
      .catch((error) => {
        console.error("Error updating tags:", error);
        renderAlertMessage("Failed to update tags");
      });
  };



  // Note actions
  const noteActions = (noteId, noteType) => (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => handleEdit(noteId, noteType)}
        style={{ display: "flex", alignItems: "center", padding: "8px 16px" }}
      >
        <EditIconSidebar style={{ marginRight: 12, fontSize: "20px" }} />
        <span style={{ marginLeft: 8 }}>Edit</span>
      </Menu.Item>

      <Menu.Item
        key="2"
        onClick={() => handlePin(noteId, noteType)}
        style={{ display: "flex", alignItems: "center", padding: "8px 16px" }}
      >
        <NotePinIcon style={{ marginRight: 12, fontSize: "20px" }} />
        <span style={{ marginLeft: 8 }}>Pin</span>
      </Menu.Item>

      <Menu.Item
        key="3"
        danger
        onClick={() => handleDelete(noteId, noteType)}
        style={{ display: "flex", alignItems: "center", padding: "8px 16px" }}
      >
        <NoteDeleteIcon style={{ marginRight: 12, fontSize: "20px" }} />
        <span style={{ marginLeft: 8 }}>Delete</span>
      </Menu.Item>
    </Menu>

  );

  const handlePin = (noteId, noteType) => {
    const apiPayload = {
      note_id: noteId,
      is_pinned: true,
    };

    const apiEndpoint =
      noteType === "INTERNAL" ? privateNotesApi : dispatcherNotesApi;

    apiEndpoint
      .pinNote(noteId, true)
      .then((res) => {
        if (!res.success) {
          renderAlertMessage(res.errors);
          return;
        }

        const updatePinnedNote = (notesSetter) => {
          notesSetter((prevNotes) =>
            prevNotes
              .map((note) => ({
                ...note,
                pinned: note.id === noteId, // only one gets pinned
              }))
              // pinned first
              .sort((a, b) => Number(b.pinned) - Number(a.pinned))
          );
        };

        const noteSetters = {
          DISPATCHER: setDispatchNotes,
          INTERNAL: setInternalNotes,
          CONSIGNEE: setConsigneeNotes,
        };

        const setter = noteSetters[noteType];
        if (setter) updatePinnedNote(setter);

        renderNotification("Note pinned successfully", "success");
      })
      .catch((error) => {
        console.error("Error pinning note:", error);
        renderAlertMessage("Failed to pin the note");
      });

    inputRef.current.focus();
  };

  const handleEdit = (noteId, noteType) => {
    setEditingNoteId(noteId);
    setSelectedNoteTypeForEdit(noteType)
    if (["DISPATCHER", 'DRIVER'].includes(noteType)) {
      const noteToEdit = dispatchNotes.find((note) => note.id === noteId);
      setEditedNoteContent(noteToEdit?.notes || "");
    } else if (noteType === "INTERNAL") {
      const noteToEdit = internalNotes.find((note) => note.id === noteId);
      setEditedNoteContent(noteToEdit?.notes || "");
    } else if (noteType === "DRIVER") {
      const noteToEdit = driverNotes.find((note) => note.id === noteId);
      setEditedNoteContent(noteToEdit?.notes || "");
    } else if (noteType === "CONSIGNEE") {
      const noteToEdit = consigneeNotes.find((note) => note.id === noteId);
      setEditedNoteContent(noteToEdit?.notes || "");
    }
    inputRef.current.focus();
  };

  const handleNoteCancel = () => {
    setEditingNoteId(null);
    setEditedNoteContent("");
  };

  const getTagIcon = (tag) => {
    switch (tag?.toLowerCase()) {
      case "special":
      case "pickup_special":
      case "delivery_special":
      case "linehaul_special":
        return (
          <div style={{ paddingRight: "3px" }} className="center">
            <SpecialTagIcon />
          </div>
        );
      case "hazmat":
        return (
          <div style={{ paddingRight: "3px" }} className="center">
            <HazmatTagIcon />
          </div>
        );
      case "expedite":
        return (
          <div style={{ paddingRight: "3px" }} className="center">
            <ExpediteTagIcon />
          </div>
        );
      case "appointment":
        return (
          <div style={{ paddingRight: "3px" }} className="center">
            <AppointmentIcon color="#576EC1" width="16" height="16" />
          </div>
        );
      case "priority":
        return (
          <div style={{ paddingRight: "5px" }} className="center">
            <HighPriorityTagIcon />
          </div>
        );
        case "osd" :
          return (
            <div style={{ paddingRight: "5px" }} className="center">
              <OsdTagIcon />
            </div>
          )
      default:
        return null;
    }
  };

  const menu = (
    <Menu onClick={(e) => setSelectedNoteTypeForAdd(e.key)}>
      <Menu.Item key="INTERNAL">Internal</Menu.Item>
      <Menu.Item key="DISPATCHER">Dispatch</Menu.Item>
      <Menu.Item key="CONSIGNEE">Consignee</Menu.Item>
    </Menu>
  );

  const filteredTags = useMemo(() => {
    return tags.filter((tag) => !["special"].includes(tag?.toLowerCase())).map((tag, index) => (
      <Tag key={index} className="tag textCaptilize">
        {getTagIcon(tag)}
        {_.startCase(tag)}
        {!["special", "hazmat", "priority", "expedite","pickup_special","delivery_special","linehaul_special","osd","appointment"].includes(
          tag?.toLowerCase()
        ) && (
            !locked && (<span className="close-icon" onClick={() => handleRemoveTag(tag)}>
              <TagCloseIcon width="12" height="12" />
            </span>)
          )}
      </Tag>
    ));
  }, [tags, getTagIcon, handleRemoveTag]);

  const openModal = (e) => {
    const rowContainer = e.currentTarget.closest('.row-container');
    const position = rowContainer
      ? rowContainer.getBoundingClientRect()
      : e.target.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
    
      const offsetTop = -350; 
      const offsetLeft = 0;
    
      setModalPosition({
        top: Math.min(position.bottom, viewportHeight - 16) + offsetTop,
        left: Math.min(position.right, viewportWidth - 224 - 16) + offsetLeft,
      });
    setSelectedTags([...tags]); 
    setIsModalVisible(true);
  };
  const handleAddNewTag = () => {
    if (tagInput && !availableTags.includes(tagInput)) {
      setAvailableTags((prev) => [...prev, tagInput]);
      setSelectedTags((prev) => [...prev, tagInput]);
      setTagInput("");
    }
  };
  
 const handleTagCheckboxChange = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };
  const addSelectedTags = () => {
    updateTags({tags: [...new Set([...tags, ...selectedTags])]});
    updateOrder("tags", selectedTags);
    setIsModalVisible(false);
    setTagInput("");
  };

  const filteredAvailableTags = tagInput
  ? availableTags.filter((tag) =>
      tag.toLowerCase().includes(tagInput.toLowerCase())
    )
  : availableTags;

  const sortedAvailableTags = [
    ...selectedTags,
    ...customTags
      .map((tag) => tag.name)
      .filter((tag) => !selectedTags.includes(tag)),
    ...availableTags.filter(
      (tag) =>
        !selectedTags.includes(tag) &&
        !customTags.some((customTag) => customTag.name === tag)
    ),
  ]
    .filter((tag) => !excludedTags.includes(tag))
    .filter((tag, index, self) => self.indexOf(tag) === index)
    .filter((tag) => tag.toLowerCase().includes(tagInput.toLowerCase()))
    .filter((tag) => !tag.toLowerCase().includes("special"))
    .sort((a, b) => {
      const isASelected = selectedTags.includes(a);
      const isBSelected = selectedTags.includes(b);
      if (isASelected && isBSelected) return 0;
      if (isASelected) return -1; 
      if (isBSelected) return 1;
      return a.localeCompare(b);
    });

  const timeZoneId = currentOrder?.customer_order_details?.time_zone_id || "";
  let tzShortName = currentOrder?.customer_order_details?.tz_short_name || "";
  const approvalNeeded = orderResponse?.customer_order_details?.approval_details || [];

  const formatApprovalText = (text = "") => {
  const formatted = text.replace(/_/g, " ").toLowerCase();
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

  const renderInboundOrderNumbers = () => {
    const inboundOrderNumbers = currentOrder?.customer_order_details?.inbound_order_numbers;
    const currentOrderImport = currentOrder?.customer_order_details?.is_imported;
    const isCurrentOrderBonded = currentOrder?.customer_order_details?.is_inbound;
    const importOrderNo = inboundOrderNumbers?.import_order_number;
    const inboundOrderNo = inboundOrderNumbers?.inbound_order_number;

    if (!importOrderNo && !inboundOrderNo) return null;

    return (
      <div style={{ marginBottom: "16px" }}>
        {importOrderNo && !currentOrderImport && (
          <Row
            style={{
              marginBottom: "4px",
              lineHeight: "32px",
              display: "flex",
              alignItems: "center",
            }}
            key="importOrderNumber"
          >
            <Col span={11}>
              <div className="Caption-2-Large" style={{ color: "#576ec1", fontWeight: "bold" }}>
                Import Order
              </div>
            </Col>
            <Col span={13} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span className="Caption-2-Large" style={{ color: "#111314" }}>
                {importOrderNo}
              </span>
              <Copyable
                className="orderNumberCopyIcon"
                text={importOrderNo}
                color="#576ec1"
              />
            </Col>
          </Row>
        )}

        {inboundOrderNo && !isCurrentOrderBonded && (
          <Row
            style={{
              marginBottom: "4px",
              lineHeight: "32px",
              display: "flex",
              alignItems: "center",
            }}
            key="inboundOrderNumber"
          >
            <Col span={11}>
              <div className="Caption-2-Large" style={{ color: "#576ec1", fontWeight: "bold" }}>
                Bonded Order
              </div>
            </Col>
            <Col span={13} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span className="Caption-2-Large" style={{ color: "#111314" }}>
                {inboundOrderNo}
              </span>
              <Copyable
                className="orderNumberCopyIcon"
                text={inboundOrderNo}
                color="#576ec1"
              />
            </Col>
          </Row>
        )}
      </div>
    );
  };

  const notesToRender = useMemo(() => {
    let notes = [];
    const allNotes = [...dispatchNotes, ...internalNotes, ...consigneeNotes];
    const pinnedNotes = allNotes.filter((note) => note.pinned);
    const unpinnedNotes = allNotes.filter((note) => !note.pinned);


    if (selectedNoteFilter === "ALL") {
      const sortedUnpinned = [...unpinnedNotes].sort((a, b) => new Date(b?.updated_at || 0) - new Date(a?.updated_at || 0));
      return [...pinnedNotes, ...sortedUnpinned];
    }

    if (selectedNoteFilter === "DISPATCHER") notes = dispatchNotes;
    else if (selectedNoteFilter === "INTERNAL") notes = internalNotes;
    else if (selectedNoteFilter === "CONSIGNEE") notes = consigneeNotes;

    return [...notes].sort((a, b) => new Date(b?.updated_at || 0) - new Date(a?.updated_at || 0));
  }, [dispatchNotes, internalNotes, consigneeNotes, selectedNoteFilter]);

  return (
    <>
    <Layout
      className="create-order-sidebar"
      style={{
        height: "calc(100vh - 50px)",
      }}
    >
      <Tabs defaultActiveKey="Summary"  centered>
        <TabPane  tab={<div data-testid="details-tab-button" style={{justifyContent: "center", width: "88px"}} className="tab-label">Details</div>} key="Summary">
          <div data-testid="details-tab-view" className="NotesTabSidebar" style={{
            position: "relative",
            overflowY: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
            onScroll={checkScrollPosition}
>
            <div>
              <div style={{height:"100%"}}>
              <div className={!locked ? "custom-scrollbar" : ""}
               ref={sidebarRef}
              >
            <div className="status-container" data-testid="status-view">
             <div className="status-text">Status</div>
              <div>
                <OrderStatusDropdown
                orderResponse={orderResponse}
                getOrderDetails={refreshDetails}
                currentOrg={currentOrg}
                organizationSettings={organizationSettings || {}}
                locked={locked}
                exception_message={currentOrder.customer_order_details.exception_message}
                isDisabled={["PENDING", "REJECTED"].includes(orderResponse?.status) || locked}
              />
              </div>
           </div>
           {approvalNeeded.length > 0 && (
              <div
                style={{
                  color: "#FFFFFF",
                  background: "#1A1424",
                  padding: "6px",
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                  borderRadius: "8px",
                }}
              >
                {approvalNeeded.map((approval, index) => (
                  <span key={index}>
                    {formatApprovalText(approval)}
                    {index !== approvalNeeded.length - 1 && ", "}
                  </span>
                ))}
                {" "}Approval Needed
              </div>
            )}
              {/* instructions */}
              <div style={{ minHeight: "88px" }} data-testid="instructions-view">
                <div className="instructions-container">
                  <Row
                    className="instructions-header"
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                    onMouseEnter={() => setHoveredField('instructions')}
                    onMouseLeave={() => setHoveredField(null)}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span>Instructions</span>
                      {hoveredField === 'instructions' && (
                        <InfoTooltip
                          label="Instructions"
                          icon={<InstructionsAddIcon />}
                          message={[
                            "Include special instructions or notes from the shipper. Drivers can view these details, ranging from contact times to specific delivery or pickup requirements.",
                          ]}
                        />
                      )}
                    </div>
                  </Row>
                </div>
                
                <Popover
                  //overlayStyle={{ minWidth: '20%' }}

                  content={
                   
                    <div style={{ minWidth: 300}} data-testid="instructions-modal">
                      <TextArea
                        data-testid="instructions-input"
                        rows={5}
                        value={tempNotes}
                        onChange={(e) => setTempNotes(e.target.value)}
                      />
                      <div style={{ marginTop: "8px", textAlign: "right" }}>
                        <Button
                          data-testid="cancel-instructions-button"
                          className="button-2-large"
                          type="link"
                          onClick={handleInstructionsCancel}
                          style={{ marginRight: "8px" }}
                        >
                          Cancel
                        </Button>
                        <Button
                          data-testid="save-instructions-button"
                          className="button-2-large"
                          type="link"
                          onClick={handleInstructionsSave}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  }
                  trigger={locked ? [] :["click"]}
                  visible={isInstructionsPopoverVisible}
                  onVisibleChange={setIsInstructionsPopoverVisible}
                  placement="bottom"
                >
                  <div
                    data-testid="add-instructions-button"
                    style={{
                      position: "relative",
                      // display: "flex",
                      // justifyContent: "space-between",
                      // alignItems: "center",
                      width: "100%",
                      borderRadius: isHoveringInstructions ? "8px" : "0",
                      backgroundColor: isHoveringInstructions
                        ? "#eff2fb"
                        : "transparent",
                      padding: "5px",
                      transition:
                        "background-color 0.3s ease, border-radius 0.3s ease",
                    }}
                    onMouseEnter={() => {
                      setIsHoveringInstructions(true);
                      const notesWithNewlines = notes.replace(/<br\s*\/?>/gi, '\n');
                      setTempNotes(notesWithNewlines);
                    }}
                    onMouseLeave={() => setIsHoveringInstructions(false)}
                  >
                    <Row>
                      <Col span={22}>
                        <div style={{
                          maxHeight: "88px",
                          overflowY: "auto",
                          overflowX: "hidden",
                          WebkitOverflowScrolling: "touch",
                          scrollbarWidth: "none",
                        }}
                          onWheel={(e) => e.stopPropagation()}>

                          {notes.length === 0 ? (
                            <span style={{ display: "flex", alignItems: "center" }}>
                              <span
                                className="button-2-large"
                                style={{ marginLeft: "4px" }}
                              >
                                Add Instructions
                              </span>
                            </span>
                          ) : (
                            // Render formatted notes as HTML
                            <span className="notes-content" dangerouslySetInnerHTML={{ __html: notes }} />
                          )}
                        </div>
                      </Col>
                      {isHoveringInstructions && notes && (
                        <Col data-testid="edit-instructions-icon" span={2} style={{ textAlign: "right" }}>
                          {!locked&&(
                          <EditIconSidebar
                            onClick={handleInstructionsEdit}
                            style={{
                              cursor: "pointer",
                            }}
                          />
                          )}
                        </Col>
                      )}
                    </Row>
                  </div>
                </Popover>
              </div>

              {/* Reference Numbers */}
              <ReferenceNumberSectionView
                currentOrder={currentOrder}
                currentOrg={currentOrg}
                consolidatedData={consolidatedData}
                setActiveKey={setActiveKey}
                orderResponse={orderResponse}
                doRefreshDetails={refreshDetails}
                isLocked={locked}
                updateReferences={updateReferences}
                orgRules={orgRules}
              />
              {/* Import/Inbound Order Numbers */}
              {renderInboundOrderNumbers()}

              {/* Options Section */}
              <OptionsSectionView
                key={currentOrder?.label_code}
                currentOrder={currentOrder}
                currentOrg={currentOrg}
                onTagsUpdate={handleTagsUpdate}
                orgSettings={organizationSettings}
                isLocked={locked}
                orgRules={orgRules}
                updateOptionsAndTags={updateOptionsAndTags}
                refreshDetails={refreshDetails}
                autoOpenImportModal={autoOpenImportModal}
                onImportModalOpened={onImportModalOpened}
                delivery_location_details={currentOrder?.delivery_location_details}
              />
              {/* Tags Section */}
              <div className="row-container" data-testid="tags-view-container">
            <Row
              className="TagSectionContainer"
              gutter={8}
              type="flex"
              justify="space-between"
              align="middle"
            >
              <Col className="heading-3-large">
              <div style={{ display: "flex", gap: "8px", justifyContent: "space-between" }}  onMouseEnter={() => setHoveredField('tags')}
              onMouseLeave={() => setHoveredField(null)} >
                    <span className="heading-3-large">Tags</span>
                    {hoveredField === 'tags' && (
                      <InfoTooltip
                        label="Tags"
                        icon={<TagsTooltipIcon />}
                        message={[
                          "Tags help you categorize orders for searching and route planning. They can also mark important details you need to know about an order.",
                        ]}
                      />
                    )}
                  </div>
              </Col>
              <Col>
              {!locked &&(
                <Button_v2
                  data-testid="add-tag-button"
                  className="small-btn flat"
                  type="link"
                  onClick={openModal}
                  hoverColor="#576ec1"
                >
                  Add Tag
                  <div className="hover-overlay"></div>
                </Button_v2>
              )}
              </Col>
            </Row>
          </div>
              <Modal
                className="TagSectionContainer"
                title={
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    Add Tags
                    <TagsModalCloseIcon onClick={() => setIsModalVisible(false)} />
                  </div>
                }
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={
                  sortedAvailableTags.length === 0 && tagInput ? null : (
                    <div
                      style={{
                        position: "relative",
                        top: "8px",
                        maxHeight: "24px",
                        height: "20px",
                        overflow: "hidden",
                      }}
                      data-testid="save-tags-button"
                    >
                      <span className="button-2-large" onClick={addSelectedTags}>
                        {selectedTags.length > 1 ? "Add Tags" : "Add Tag"}
                      </span>
                    </div>
                  )
                }
                width={224}
                closable={false}
                style={{
                  position: "absolute",
                  top: modalPosition.top,
                  left: modalPosition.left,
                  maxHeight: "90vh",
                  overflow: "auto",
                }}
              >
                <Input
                  data-testid="tag-name-input"
                  placeholder="Tag Name"
                  value={tagInput}
                  onChange={handleTagInputChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleAddNewTag();
                    }
                  }}
                />
                <div
                  style={{
                    marginTop: "16px",
                    maxHeight: "202px",
                    overflowY: "auto",
                    border: "1px solid #e0e0e0",
                    borderRadius: "4px",
                  }}
                >
                  {sortedAvailableTags.map((tag) => (
                    <div
                      key={tag}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: "40px",
                        padding: "0 8px",
                      }}
                    >
                      <span className="TagStyle">{_.startCase(tag)}</span>
                      <Checkbox
                        data-testid={`${tag}-checkbox`}
                        checked={selectedTags.includes(tag)}
                        onChange={() => handleTagCheckboxChange(tag)}
                      />
                    </div>
                  ))}

                  {!sortedAvailableTags.some(
                    (tag) => tag.toLowerCase() === tagInput.toLowerCase()
                  ) && tagInput && (
                      <div
                        data-testid="click-tag-button"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontWeight: "bold",
                          cursor: "pointer",
                          marginTop: "8px",
                          padding: "0 8px",
                        }}
                        onClick={handleTagSubmit}
                      >
                        <span>Add '{tagInput}' Tag</span>
                      </div>
                    )}
                </div>
              </Modal>

          <Row style={{ paddingBottom: "16px" }}>
            <div className="tags-section">{filteredTags}</div>
          </Row>
          </div>
          {!isShipper && <div style={{position:"fixed", bottom:"15px", right:"17px", minHeight:"40px"}}>
            <EstimateBill  
            currentOrder={currentOrder}   
            setViewTab={setViewTab} 
            setActiveKey={setActiveKey} 
            goToTab={goToTab} 
            setShowDrawer={setShowDrawer} 
            estimateRefreshKey={estimateRefreshKey} 
            setEstimateRefreshKey={setEstimateRefreshKey}
            onUnmount={onUnmount}
            />
          </div>}
              </div>
              {/* <div>
                <Row gutter={8} justify="space-between" align="middle">
                  <Col className="heading-3-large" span={14}>
                    Tags
                  </Col>
                  <Col span={10}>
                    <Popover
                      content={
                        <div
                          style={{
                            width: "calc(100% - 16px)",
                            maxWidth: "224px",
                          }}
                        >
                          <Input
                            placeholder="Tag Name"
                            value={tagInput}
                            onChange={(e) => setTagInput(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleTagSubmit();
                              }
                            }}
                          />
                          <Button
                            className="button-2-large"
                            type="link"
                            onClick={handleTagSubmit}
                            style={{ marginTop: "8px" }}
                          >
                            Add Tag
                          </Button>
                        </div>
                      }
                      trigger="click"
                      visible={isPopoverVisible}
                      onVisibleChange={setIsPopoverVisible}
                      placement="bottom"
                    >
                      <Button_v2 className="small-btn flat" type="link">
                        Add Tag
                      </Button_v2>
                    </Popover>
                  </Col>
                </Row>
                <div className="tags-section">
                  {tags.map((tag, index) => (
                    <Tag key={index} className="tag textCaptilize">
                      {getTagIcon(tag)}
                      {tag}
                      {!["special", "hazmat", "priority", "expedite"].includes(
                        tag
                      ) && (
                          <span
                            className="close-icon"
                            onClick={() => handleRemoveTag(tag)}
                          >
                            <TagCloseIcon width="12" height="12" />
                          </span>
                        )}
                    </Tag>
                  ))}
                </div>
              </div> */}

            </div>
           
            
          </div>
          <style>
            {`
      @keyframes bounce {
        0%, 100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(8px);
        }
      }
      .NotesTabSidebar::-webkit-scrollbar {
        display: none;
      }
    `}
          </style>
        </TabPane>

        {/* Notes Tab */}
        <TabPane
          tab={<div data-testid="notes-tab-button" style={{justifyContent: "center", width: "88px"}} className="tab-label"> Notes
            <div className="badge">
                {dispatchNotes.length + internalNotes.length + consigneeNotes.length}
            </div>
          </div>
          }
          key="Notes"
        >
          <div className="NotesTabSidebar" data-testid="notes-view">
            <div style={{ paddingBottom: "12px" }}>
              <div
                className="select-dropdown-notes"
                style={{ padding: "12px 0" }}
              >
                <Select
                  data-testid="notes-dropdown"
                  suffixIcon={<Icon style={{ color: "#576ec1", position: "absolute" }} type="caret-down" />}
                  className="heading-3-large"
                  value={selectedNoteFilter}
                  onChange={(value) => setSelectedNoteFilter(value)}
                  onDropdownVisibleChange={handleDropdownChange}
                  dropdownAlign={{ offset: [0, -30] }}
                  dropdownStyle={{ minWidth: "224px", borderRadius: "8px", boxShadow: "0px -4px 16px 0px rgba(0, 0, 0, 0.08), 0px 16px 24px 0px rgba(0, 0, 0, 0.16), 0px 16px 24px 0px rgba(0, 0, 0, 0.12)" }}
                >
                  {noteFilterOptions.map(({ value, label }) => (
                    <Select.Option
                      key={value}
                      value={value}
                      style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                    >
                      {label}
                      {open && selectedNoteFilter === value && <SelectedTickMarkIcon />}
                    </Select.Option>
                  ))}
                </Select>

              </div>
              <div
                style={{
                  flex: "1 1 auto",
                  overflowY: "auto",
                  marginBottom: "12px",
                  maxHeight: "calc(100vh - 300px)",
                }}
              >
                  {notesToRender.map((note) => (
                      <Card
                    data-testid="note-card"
                    key={note?.id}
                    className="note-card"
                    style={{ marginBottom: "12px", position: "relative" }}
                  >
                    {(() => {
                      const invoiceApprovalDate = orderResponse?.customer_order_details?.invoice_approval_date;
                      tzShortName = note?.tz_short_form || tzShortName;
                      let allowMenu = true;
                      if (invoiceApprovalDate && note?.updated_at) {
                        const noteDate = new Date(note?.updated_at);
                        const approvalDate = new Date(invoiceApprovalDate);
                      if (!isNaN(noteDate) && !isNaN(approvalDate) && noteDate > approvalDate) {
                        allowMenu = true;
                      } else {
                        allowMenu = false;
                      }
                      }
                      if (['DRIVER'].includes(note?.type)) allowMenu = false;
                      return allowMenu ? (  
                        <div className="actions-icons" data-testid="notes-actions-dropdown">
                      <Dropdown
                        overlay={noteActions(note?.id, note?.type)}
                        trigger={["click"]}
                      >
                        <NotesEditMenuIcon
                          className="edit-menu-icon"
                          style={{
                            cursor: "pointer",
                          }}
                        />
                      </Dropdown>
                    </div>
                  ) : null;
                })()}

                    {editingNoteId === note.id ? (
                      <Popover
                        content={
                          <div>
                            <TextArea
                              data-testid="edit-notes-input"
                              autoSize={{ minRows: 3, maxRows: 5 }}
                              value={editedNoteContent}
                              onChange={(e) =>
                                setEditedNoteContent(e.target.value)
                              }
                            />
                            <div
                              style={{ marginTop: "8px", textAlign: "right" }}
                            >
                              <Button
                                data-testid="cancel-note-button"
                                onClick={handleNoteCancel}
                                style={{ marginRight: "8px" }}
                              >
                                Cancel
                              </Button>
                              <Button
                                data-testid="save-note-button"
                                type="primary"
                                onClick={() => handleAddNote(note.id, note.type, 'update')}
                                disabled={!editedNoteContent}
                              >
                                Save
                              </Button>
                            </div>
                          </div>
                        }
                        title="Edit Note"
                        trigger="click"
                        visible={true}
                        placement="bottom"
                      />
                    ) : (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <strong>{note.last_updated_by || emptyText}</strong>
                          <div
                            data-testid="notes-pin-icon"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {note.pinned && (
                              <NotePinnedIcon
                                style={{
                                  marginRight: "8px", 
                                  color: "orange",
                                }}
                              />
                            )}
                          </div>
                        </div>
                        {note && note?.updated_at &&
                        <div className="order_notes_time">
                         <DisplayTime
                            dateTimeString={note?.updated_at}
                            displayWithDate={true}
                            timeZoneId={timeZoneId}
                            isUTC={false}
                            tz_short_name={tzShortName}                                  
                         />
                       </div>}
                        <div className="order_notes_text">
                              {typeof note?.notes === "string"
                                ? note.notes
                                : note?.notes?.text || ""}
                            </div>
                        <div
                          className={`note-type-badge ${note?.notes_type === "Driver" ? "orange" : "blue"} outline small`}
                        >
                          {getLabel(note?.type)}
                        </div>
                      </>
                    )}
                  </Card>
                ))}
              </div>
            </div>

            
              <Spin spinning={inProgress}>
                <div style={{ padding: "12px 0" }}>
                  <Input
                    data-testid="add-notes-input"
                    ref={inputRef}
                    className="custom-input"
                    placeholder="Add Note"
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleAddNote();
                      }
                    }}
                    loading={isLoading}
                    readOnly={isLoading}
                    style={{ outline: "none" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      marginTop: "8px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div data-testid="notes-type-dropdown">
                      <Dropdown
                        overlay={menu}
                        trigger={["click"]}
                        placement="topCenter"
                        overlayStyle={{ borderRadius: "8px", boxShadow: "0px -4px 16px 0px rgba(0, 0, 0, 0.08), 0px 16px 24px 0px rgba(0, 0, 0, 0.16), 0px 16px 24px 0px rgba(0, 0, 0, 0.12)" }}
                      >
                        <Button className="dropdown-font" style={{ border: "1px solid black" }}>
                          {getLabel(selectedNoteTypeForAdd)}
                          <Icon style={{ color: "#576ec1", marginLeft: "8px" }} type="caret-down" />
                        </Button>
                      </Dropdown> 
                    </div>

                    <div>
                      <Button
                        data-testid="add-note-button"
                        className="small-btn raised"
                        onClick={() => handleAddNote(null)}
                        type="primary"
                        disabled={!newNote}
                      >
                        Add Note
                      </Button>
                    </div>
                  </div>
                </div>
              </Spin>
          </div>
        </TabPane>
      </Tabs>
    </Layout>
    {isOverflowing && !atBottom && (
              <div
                style={{
                  position: "absolute",
                  bottom: "33%",
                  left: "85%",
                  transform: "translateX(-50%)",
                  animation: "bounce 1.5s infinite",
                  zIndex: 10,
                  cursor: "pointer",
                }}
              >
              <Icon  onClick={handleScrollToEnd} type="arrow-down" style={{ color:"#576ec1", fontSize:"32px" }} />
              </div>
            )}
    </>
  );
};

export default OrderViewSidebar;